import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AGIndustries.css';
import emailjs from '@emailjs/browser';

const Sponsors = () => {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

   const handleCall = () => {
   window.open('https://wa.me/525574413913', '_blank'); };
   const handleEmail = async () => {
    if (!correo) {
      alert('Por favor ingresa tu correo.');
      return;
    }
    setCargando(true);
    try {
      await emailjs.send(
     'service_ylmhlh3',
     'template_3dg5syr',
        {
          correo_sponsor: correo,
          mensaje_sponsor: mensaje || 'Sin mensaje adicional',
        },
        'eKtUZ0SOujh9EuJQC' 
      );
      setEnviado(true);
    } catch (error) {
      console.error(error);
      alert('Hubo un error al enviar. Intenta de nuevo.');
    } finally {
      setCargando(false);
    }
  };

  const inputStyle = {
    width: '250px',
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid rgba(255,255,255,0.6)',
    color: '#fff',
    fontFamily: 'Georgia, serif',
    fontSize: '13px',
    letterSpacing: '0.1em',
    padding: '10px 8px',
    outline: 'none',
    textShadow: '0 1px 4px rgba(0,0,0,0.6)',
  };

  const buttonStyle = {
    fontFamily: 'Georgia, serif',
    fontSize: '12px',
    letterSpacing: '0.2em',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.3)',
    padding: '15px 30px',
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '4px',
    backdropFilter: 'blur(10px)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    width: '250px',
    textAlign: 'center'
  };

  return (
    <div className="sx-wrapper">
      <div className="sx-video-bg">
        <video autoPlay muted loop playsInline className="sx-video">
          <source src="/Vino1.mp4" type="video/mp4" />
        </video>
        <div className="sx-video-overlay" />
      </div>

      <header className={`sx-header ${scrolled ? 'scrolled' : ''}`}
        style={{ alignItems: 'flex-start', paddingTop: '13px', position: 'fixed', width: '100%', zIndex: 1002 }}>
        <button
          onClick={() => navigate('/')}
          className="sx-back-btn"
          style={{
            background: 'none', border: 'none', color: '#fff',
            cursor: 'pointer', fontSize: '22px', opacity: 0.75,
            transition: 'opacity 0.3s ease', padding: '6px',
            marginLeft: '4px', marginTop: '1px', display: 'flex',
            alignItems: 'center', justifyContent: 'center'
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = 1}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.75}
          aria-label="Volver"
        >
          &#8592;
        </button>
        <span className="sx-registrate-label" style={{
          position: 'absolute', left: '50%',
          transform: 'translateX(-50%)', fontFamily: 'Georgia, serif',
          fontSize: '15px', letterSpacing: '0.31em',
          textTransform: 'uppercase', color: '#fff', opacity: 0.9
        }}>
          Sponsors
        </span>
      </header>

      <div style={{
        position: 'relative', zIndex: 10, display: 'flex',
        flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100vh', gap: '20px'
      }}>
        {enviado ? (
          <p style={{
            fontFamily: 'Georgia, serif', color: '#fff',
            fontSize: '18px', textAlign: 'center', opacity: 0.85
          }}>
            Tu propuesta ha sido enviada, pronto nos pondremos en contacto.
          </p>
        ) : (
          <>
            <input
              type="email"
              placeholder="Tu correo electrónico"
              value={correo}
              onChange={e => setCorreo(e.target.value)}
              style={inputStyle}
            />
            <textarea
              placeholder="Mensaje (opcional)"
              value={mensaje}
              onChange={e => setMensaje(e.target.value)}
              rows={3}
              style={{ ...inputStyle, resize: 'none', lineHeight: '1.6' }}
            />
            <button
              onClick={handleEmail}
              disabled={cargando}
              style={buttonStyle}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
            >
              {cargando ? 'Enviando...' : 'Enviar propuesta'}
            </button>

            <button
              onClick={handleCall}
              style={{ ...buttonStyle, border: '1px solid rgba(255,255,255,0.15)' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
            >
              Llamar ahora
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Sponsors;